import { createContext, useContext, useEffect, type ReactNode } from "react";

/** Üst çubuktaki konum (ui.md §12.3). Alt sayfa kendi konumunu (ör. "Veri Kaynakları › Yükleme #12") buraya yazar; yazmazsa üst çubuk ekran adını gösterir. */
export const LocationContext = createContext<(node: ReactNode) => void>(() => {});

export function useLocationSlot(node: ReactNode, deps: unknown[]) {
  const set = useContext(LocationContext);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { set(node); return () => set(null); }, [set, ...deps]);
}
